<div class="reale-theme-style2 fs-6" fxLayout="column">
  <div fxLayout="column" class="wrapper">
    <header [configuration]="headerConfiguration"></header>
    <app-title [data]="titleData"></app-title>
  </div>
  
  <div fxLayout="row" fxLayoutAlign="space-between" class="components-container">
    <div fxLayout="column">
      <app-product-price-form [isReadOnly]="false"></app-product-price-form>
      <app-coverages-drop-downs [isReadOnly]="false"></app-coverages-drop-downs>
    </div>
    <app-coverage-price-card [isReadOnly]="false"></app-coverage-price-card>
  </div>
  
  <app-footer></app-footer>
</div>
